import { NavLink } from 'react-router-dom'
import IconUser from '@/components/icons/IconUser'

export default function Account() {
  return (
    <div className="header-icon-button-container">
      <NavLink className="header-icon-button" to="/account">
        <IconUser />
      </NavLink>
    </div>
  )
}
